module.exports = __webpack_public_path__ + "img/stock5.1c4af8d1.png";